import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gerelt/front/app/podcast/[slug]/PodcastDetailClient.js");
